import React from "react";
import { Typography, Box } from "@material-ui/core";

function TitleIXContactText() {
  return (
    <>
      <Box style={{ margin: "24px 0 24px 0" }}>
        <Typography>
          University of Phoenix is required to prohibit discrimination and to provide reasonable accommodations and modifications to qualified students in all University programs and activities under the law.
        </Typography>
      </Box>

      <Box style={{ margin: "24px 0 24px 0" }}>
        <Typography>
          The University does not discriminate on the basis of sex and prohibits sex discrimination in any education program or activity that it operates, as required by Title IX, including sex discrimination based on pregnancy or related conditions or parental status.
        </Typography>
      </Box>

      <Box style={{ margin: "24px 0 24px 0" }}>
        <Typography>
          As faculty of University of Phoenix, you are responsible for implementing any approved accommodations. Accommodations are determined after a deliberative and interactive process between the student and University staff. Accommodations must be provided as indicated, following all guidelines and directives in the accommodation notification.
        </Typography>
      </Box>
    </>
  );
}

export default TitleIXContactText;
